import { Box, Typography, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import AuthLayout from "../../layout/AuthLayout";
import { colors } from "../../theme/theme";
import { CustomInput } from "../../components/Common/CustomInput";
import { EmailOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { CustomBtn } from "../../components/Common/CustomBtn";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const smScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // const mdScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const [email, setEmail] = useState("");
  return (
    <AuthLayout fullHeight>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
          height: "100%",
        }}
      >
        <Typography
          sx={{
            color: colors.primary,
            fontSize: "28px",
            fontFamily: "Mulish-ExtraBold",
            textAlign: "center",
          }}
        >
          Reset Your Password
        </Typography>
        <Typography
          sx={{
            color: colors.primary,
            fontSize: "14px",
            fontFamily: "Mulish-SemiBold",
          }}
        >
          Enter your email address to receive a password reset link.
        </Typography>

        <Box
          sx={{
            width: "100%",
            height: "100%",
            mt: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box sx={{ width: "100%" }}>
            <CustomInput
              label="Email address"
              placeholder="e.g., hello@imzul.com"
              type={"email"}
              Icon={EmailOutlined}
              width={"100%"}
              mT={2}
              value={email}
              handleChange={(e) => setEmail(e.target.value)}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              mt: 4,
              gap: 2,
              width: "100%",
            }}
          >
            <CustomBtn
              width={smScreen ? "100%" : "75%"}
              text="Send Reset Link"
              icon
              fontSize={"16px"}
            />

            <Typography
              sx={{
                color: colors.primary,
                fontFamily: "Mulish-Regular",
                fontSize: "12px",
              }}
            >
              Already have an account?{" "}
              <Typography
                component={"span"}
                sx={{
                  color: colors.secondary,
                  fontFamily: "Mulish-Bold",
                  fontSize: "12px",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => navigate("/sign-in")}
              >
                Sign In
              </Typography>
            </Typography>
          </Box>
        </Box>
      </Box>
    </AuthLayout>
  );
};

export default ForgotPassword;
